(function(){
  if(window.phcSizeBuyReady) return; window.phcSizeBuyReady=true;
  document.addEventListener('click',function(e){
    var size=e.target.closest('.phc-sb__size');
    if(size){
      var box=size.closest('[data-phc-sb]'); if(!box||size.disabled) return;
      box.querySelectorAll('.phc-sb__size').forEach(function(x){x.setAttribute('aria-pressed','false')});
      size.setAttribute('aria-pressed','true');
      var add=box.querySelector('[data-sb-add]'); add.dataset.id=size.dataset.id;
      box.querySelector('[data-sb-price]').textContent=size.dataset.price;
      box.querySelector('[data-sb-compare]').textContent=size.dataset.compare||'';
      var card=box.closest('.card-wrapper'); var im=card&&card.querySelector('.card__media img');
      if(im&&size.dataset.img&&im.getAttribute('src')!==size.dataset.img){im.removeAttribute('srcset');im.src=size.dataset.img;}
      return;
    }
    var btn=e.target.closest('[data-sb-add]');
    if(!btn||!btn.dataset.id) return;
    e.preventDefault();
    var label=btn.textContent; btn.disabled=true; btn.textContent='Adding\u2026';
    var drawer=document.querySelector('cart-drawer');
    fetch((window.Shopify&&Shopify.routes?Shopify.routes.root:'/')+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:Number(btn.dataset.id),quantity:1}],sections:'cart-drawer,cart-icon-bubble',sections_url:window.location.pathname})})
      .then(function(r){return r.json()})
      .then(function(res){
        if(res.status){throw new Error(res.description||'error')}
        if(drawer&&typeof drawer.renderContents==='function'){drawer.renderContents(res);}else{window.location.href='/cart';}
        document.dispatchEvent(new CustomEvent('cart:updated'));
      })
      .catch(function(){window.location.href='/cart';})
      .finally(function(){btn.disabled=false;btn.textContent=label;});
  });
})();
